// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"63f0dafc","148":"7a966d8f","438":"d7dd635b","641":"4cb23346","787":"526da4e5","904":"41aadd1e","926":"3001807c"}[chunkId] + ".chunk.js";
};